import { A4uBoxImport as IconComponent } from '@adobe/react-spectrum-workflow/dist/BoxImport.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function BoxImport(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}